import { useNavigate } from "react-router-dom"
import { gql } from "~/__generated__"
import { FlashMessageType, useFlashMessage } from "~/common/flash-message-context"
import { groupDetailPath } from "~/common/paths"
import { useSafeMutation } from "~/common/use-safe-mutation"

const JOIN_GROUP_MUTATION = gql(/* GraphQL */ `
  mutation JoinGroup($input: JoinGroupInput!) {
    joinGroup(input: $input) {
      group {
        id
        name
      }
    }
  }
`)

export const useJoinGroup = () => {
  const [joinGroup, { loading }] = useSafeMutation(JOIN_GROUP_MUTATION)
  const navigate = useNavigate()
  const { showFlashMessage } = useFlashMessage()

  const handleJoinGroup = async (shareToken: string, invitedById?: string | null) => {
    const result = await joinGroup({
      variables: {
        input: {
          shareToken,
          invitedById: invitedById ?? undefined,
        },
      },
    })

    if (!result.data) {
      showFlashMessage({
        message: result.errors?.[0].message ?? "Error joining group",
        type: FlashMessageType.error,
      })
      return false
    }

    showFlashMessage({
      message: `You've joined the ${result.data.joinGroup.group.name} Group. You can now add bookmarks to this group and will receive updates when others add theirs as well.`,
      type: FlashMessageType.success,
    })
    navigate(groupDetailPath({ id: result.data.joinGroup.group.id }))
    return true
  }

  return {
    joinGroup: handleJoinGroup,
    loading,
  }
}
